/* global app */
/* global event */
/* global users */
app.controller('usersCtrl', ['$rootScope', '$scope', '$http', '$compile', 'NetworkService', 'AtlasDialog', 'AtlasNotification', function($rootScope, $scope, $http, $compile, NetworkService, AtlasDialog, AtlasNotification) {

    $scope.users = users;
    
    $scope.openUser = function(id){
        window.location = "/user/"+id
    }
}])
